module.exports = __webpack_public_path__ + "img/report-active.57ca56b0.svg";